<script setup lang="ts">
    import { useAppStore } from '#imports';
    import { usePageStore } from '#imports';

    /* Store variables */
    const { isMenu } = storeToRefs(useAppStore());
    const { pages } = storeToRefs(usePageStore());
</script>

<template>
    <v-navigation-drawer
        v-model="isMenu"
        style="border-right: 1px solid rgb(var(--v-theme-surfaceEdgeRight))"
        width="180">
        <v-list aria-name="Navigation Drawer" aria-role="list">
            <v-list-item v-for="(page) in pages.filter(p => p.isShow)"
                :aria-name="page.title"
                :to="page.to"
                :key="page.id"
                :value="page.id"
                color="primary"
                variant="text">
                <template #prepend>
                    <v-icon :icon="page.icon" />
                </template>
                <v-list-item-title>{{ page.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>